// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2K8vq","productName":"Table_productName__1Tl6U"};